"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const explorer_component_1 = require("./explorer.component");
const AppRoutes = [
    { path: '', redirectTo: 'Dataset', pathMatch: 'full' },
    { path: ':filter', component: explorer_component_1.ExplorerComponent, pathMatch: 'full' },
    { path: ':filter/:folderId', component: explorer_component_1.ExplorerComponent, pathMatch: 'full' }
];
class ExplorerModule {
}
exports.ExplorerModule = ExplorerModule;
